/**
 * Insight Card.
 * Displays individual insights detected in the dataset.
 */

import React from 'react';
import type { InsightItem } from '@excel-ai-studio/shared';
import { INSIGHT_KIND_LABELS } from '@excel-ai-studio/shared';
import { ResultCard } from '../common/ResultCard';

interface InsightCardProps {
  readonly insights: readonly InsightItem[];
}

const severityIcons: Record<string, string> = {
  info: 'ℹ️',
  warning: '⚠️',
  positive: '✅',
};

export const InsightCard: React.FC<InsightCardProps> = ({ insights }) => {
  if (insights.length === 0) return null;

  return (
    <ResultCard
      title="Insights détectés"
      variant="analysis"
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {insights.map((insight) => (
          <div
            key={insight.id}
            style={{
              borderLeft: `4px solid ${
                insight.severity === 'positive'
                  ? '#107c10'
                  : insight.severity === 'warning'
                    ? '#ffb900'
                    : '#0078d4'
              }`,
              paddingLeft: '12px',
              paddingBottom: '12px',
              borderBottom: '1px solid #e0e0e0',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
              <span>{severityIcons[insight.severity || 'info']}</span>
              <span style={{ fontWeight: 'bold', fontSize: '13px' }}>
                {INSIGHT_KIND_LABELS[insight.kind]}
              </span>
            </div>
            <div style={{ fontSize: '13px', marginBottom: '4px' }}>{insight.title}</div>
            <div style={{ fontSize: '12px', color: '#666' }}>{insight.description}</div>
            {insight.columns && insight.columns.length > 0 && (
              <div style={{ fontSize: '11px', color: '#999', marginTop: '4px' }}>
                Colonnes: {insight.columns.join(', ')}
              </div>
            )}
          </div>
        ))}
      </div>
    </ResultCard>
  );
};
